import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Dashboard } from '@app/models/backend/dashboard';
import { DashboardComponent } from '@app/pages/home/pages/dashboard/dashboard.component';
import { environment } from '@src/environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  api = environment.apiEndPoint;
  userBalance!: Dashboard;
  profilePic: any;
  isUserBalanceLoaded : boolean = false;

  userBalance1:BehaviorSubject<any>  = new BehaviorSubject<any>({});

  constructor(private http: HttpClient) 
  {
    const user = JSON.parse(localStorage.getItem('user')!);
    // if (user?.isPartyUser && !this.isUserBalanceLoaded) {
    //   this.getBalance();
    // }
  }

  userProfile() {
    return this.http.get( this.api+'/User/Profile');
  }

  userProfileByid(id: any) {
    if(id === null){
      return this.http.get( this.api+'/Profile')
    } else {
      return this.http.get( this.api+'/Profile?UserId='+id);
    } 
  }

  allusers(activePage: any, data: any) {
    return this.http.get( this.api+'/Profile/GetAll?PageIndex='+ activePage, {params:data});
  }

  getAllUserCsv(data: any) {
    return this.http.get(this.api+'/Profile/GetCsv', {params: data, responseType: 'blob'});
  }

  allbusinesss(activePage: any, data: any) {
    return this.http.get( this.api+'/Business/GetAllLeads?PageIdex='+ activePage, {params: data});
  }

  getAllBusinessCsv(data: any) {
    return this.http.get(this.api+'/Lead/GetCsv', {params: data, responseType: 'blob'});
  }

  businessProfile(id: any) {
    return this.http.get( this.api+'/Business?BusinessId='+ id);
  }

  leadById(id: any) {
    return this.http.get( this.api+'/Lead?BusinessId='+ id);
  }

  getBalancedData() {
    return this.http.get( this.api+'/Dashboard');
  }

  businessUpdate(data: any) {
    return this.http.put( this.api+'/Business', data);
  }

  businessCreate(data: any) {
    return this.http.post( this.api+'/Business', data);
  }

  userUpdate(data: any) {
    return this.http.put( this.api+'/User', data);
  }

  setUserStatus(data: any) {
    return this.http.put( this.api+'/User/UpdateStatus', data);
  }

  userCreate(data: any) {
    return this.http.post(this.api+'/User', data);
  }

  getBalance() {
    this.getBalancedData().subscribe((res: any) => {
      this.userBalance = res['data'];
      this.userBalance1.next(this.userBalance);
      this.isUserBalanceLoaded = true;
    });
  }

  faqs() {
    return this.http.get( this.api+'/FAQ/GetAll');
  }

  getUserSDMetaData() {
    return this.http.get( this.api+'/User/GetUserSD');
  }

  userrsearchData() {
    return this.http.get( this.api+'/User/GetSearchSD');
  }

  businessSearchData() {
    return this.http.get( this.api+'/Business/GetSearchSD');
  }

  clearData(){
    this.isUserBalanceLoaded = false;
    this.userBalance = {
      approvalStatusId: 0,
      approvalStatus: '',
      balancePKR: 0,
      balanceSMS: 0,
      businessCode: '',
      smsCount: 0,
      campaignCount: 0,
      totalRecharge: 0,
      productCount: 0,
      productAmt: 0,
      productExpiryDate: null as any,
      availableProductUnits: 0
    };
  }

}
